var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.5C0 3.18524 0.148194 2.88885 0.4 2.7L3.4 0.45C3.75556 0.183333 4.24444 0.183333 4.6 0.45L7.6 2.7C7.85181 2.88885 8 3.18524 8 3.5V7C8 7.55228 7.55228 8 7 8H1C0.447715 8 0 7.55228 0 7V3.5Z",
    fill: "#212D41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.588470e381a0b51954c10042aca5099f.svg";
export { ForwardRef as ReactComponent };